import { ApiProperty } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsNumber, IsUUID, Max, Min } from 'class-validator';

export class JobPhaseRequestResourceBatchDto {
  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'ID of Job whose current phase will be approved.',
  })
  @IsUUID()
  @Expose()
  jobId!: string;

  @ApiProperty({
    title: 'RequestDelayDays',
    description: 'Request Delay Days',
  })
  @IsNumber()
  @Expose()
  requestDelayDays!: number;

  @ApiProperty({
    type: 'number',
    default: null,
    title: 'Ready Hour',
    description: 'The hour of the day (0-23) when the contractor can start.',
  })
  @IsNumber()
  @Min(0)
  @Max(23)
  @Type(() => Number)
  @Expose()
  readyHour!: number;
}
